import { connect } from 'react-redux';

import { RBACWrapper } from './RBACWrapper';
import { selectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  userPerms: selectors.getIdentityState(state).permissions,
  userRoles: selectors.getIdentityState(state).roles,
});

export default connect(mapStateToProps, null)(RBACWrapper);
